// extracted by mini-css-extract-plugin
export default {"link":"styles_link__23OKZ","nav":"styles_nav__hZzfy"};